import {Component, HostListener} from '@angular/core';
import {ParcelsService} from '../../../services/parcels.service';
import {UrlService} from '../../../services/url.service';

declare const toastr: any;

@Component({
    selector: 'enter-parcel-barcode-modal',
    templateUrl: 'enter-parcel-barcode-modal.component.html',
    styleUrls: ['enter-parcel-barcode-modal.component.scss']
})
export class EnterParcelBarcodeModalComponent {
    parcelBarcode: string;

    constructor(
        public parcelsService: ParcelsService,
        public urlService: UrlService
    ) {
    }

    hideModal() {
        this.parcelsService.isEnterParcelBarcodeModalShow = false;
        this.urlService.modalClosed.emit();
    }

    getParcelByBarcode() {
        this.parcelsService.getParcelByBarcode(this.parcelBarcode)
            .subscribe(
                res => {
                    const body = JSON.parse(res._body);
                    const entities = body.entities.filter(e => e.status === 'received');
                    const parsedArray = [];
                    if (entities.length > 0) {
                        this.parcelsService.parcelsFactory(entities, parsedArray);
                        this.parcelsService.parcelInTransitModal = parsedArray[0];
                        this.parcelsService.isTransitModalShow = true;
                        this.parcelsService.statusInTransitModal = 'pick_up';
                        this.hideModal();
                    } else
                        toastr.error('There are no parcels with this barcode in received status.');
                }, error => this.parcelsService.api.errorHandler(error, 'Failed to get parcels info.')
            );
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/parcels/enter-parcel-barcode-modal/enter-parcel-barcode-modal.component.ts